import { StripeService } from 'ngx-stripe';
import { SubscriptionCheckoutService } from '../account/subscription-checkout.service';
import * as i0 from "@angular/core";
import * as i1 from "ngx-stripe";
import * as i2 from "../account/subscription-checkout.service";
var StripeApiKeyInjector = /** @class */ (function () {
    function StripeApiKeyInjector(stripe, checkoutService) {
        this.stripe = stripe;
        this.checkoutService = checkoutService;
    }
    StripeApiKeyInjector.prototype.setStripePublishableApiKey = function (stripeApiKey) {
        this.stripe.changeKey(stripeApiKey);
        this.checkoutService.setApiKey(stripeApiKey);
    };
    StripeApiKeyInjector.ngInjectableDef = i0.defineInjectable({ factory: function StripeApiKeyInjector_Factory() { return new StripeApiKeyInjector(i0.inject(i1.StripeService), i0.inject(i2.SubscriptionCheckoutService)); }, token: StripeApiKeyInjector, providedIn: "root" });
    return StripeApiKeyInjector;
}());
export { StripeApiKeyInjector };
